import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ConfigMinMaxComponent } from "./min_max/config";
import { NgxSliderModule } from "@angular-slider/ngx-slider";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AutomaticRequestDeviceComponent } from "./automatic_request/automatic_request";
import { ConfigSensorDeviceComponent } from "./config_sensor_device";
import { ConfigFuzzyLogicComponent } from "./fuzzy_logic/fuzzy_logic";
import { ConfigMaintenanceAlertComponent } from "./maintenance_alert/maintenance_alert";
import { LoadingModule } from "../loading/loading.module";
import { TranslateModule } from "@ngx-translate/core";

@NgModule({
  imports: [CommonModule, FormsModule, NgxSliderModule, ReactiveFormsModule, LoadingModule,TranslateModule],
  providers: [
    ConfigMinMaxComponent,
    AutomaticRequestDeviceComponent,
    ConfigSensorDeviceComponent,
    ConfigFuzzyLogicComponent,
    ConfigMaintenanceAlertComponent
  ],
  declarations: [
    ConfigMinMaxComponent,
    AutomaticRequestDeviceComponent,
    ConfigSensorDeviceComponent,
    ConfigFuzzyLogicComponent,
    ConfigMaintenanceAlertComponent
  ],
  exports: [
    ConfigMinMaxComponent,
    AutomaticRequestDeviceComponent,
    ConfigSensorDeviceComponent,
    ConfigFuzzyLogicComponent,
    ConfigMaintenanceAlertComponent
  ]
})
export class ConfigSensorsDeviceModule {}
